import * as React from 'react';

function SvgKickOutVisitor(props: React.SVGProps<SVGSVGElement>): any {
    return (
        <svg viewBox="0 0 32 32" width="1em" height="1em" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M4 29V3H28V18L26 16V5H6V27H13V23H19V27H28V29H17V25H15V29H4Z" fill="black" />
            <path d="M15 7H8V10H15V7Z" fill="black" />
            <path d="M15 12H8V15H15V12Z" fill="black" />
            <path d="M15 17H8V20H15V17Z" fill="black" />
            <path d="M24 7H17V10H24V7Z" fill="black" />
            <path d="M24 12H17V15H24V12Z" fill="black" />
            <path d="M20 17H17V20H20V17Z" fill="black" />
            <path d="M25.293 19.9141L26.707 18.5L30.4141 22.207L26.707 25.9141L25.293 24.5L26.5859 23.207H22V21.207H26.5859L25.293 19.9141Z" fill="black" />
        </svg>
    );
}

export default SvgKickOutVisitor;
